import { baseUrl, consumer_key_gf, secret_key_gf } from "./constants";
import { Buffer } from "buffer";

const submitFormById = async (formId: string, data: any) => {
  const endpoint = `${baseUrl}/wp-json/gf/v2/forms/${formId}/submissions/`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(endpoint, options);
  const json = await response.json();
  return json;
};

// Function to fetch the form structure by formId
const fetchFormStructureById = async (formId: string): Promise<any> => {
  const endpoint = `${baseUrl}/wp-json/gf/v2/forms/${formId}`;
  const consumerKey = consumer_key_gf;
  const consumerSecret = secret_key_gf;
  const authString = `${consumerKey}:${consumerSecret}`;
  const base64Auth = Buffer.from(authString).toString("base64");

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Auth}`,
    },
  };

  try {
    const response = await fetch(endpoint, options);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(`Error: ${error.message}`);
    }

    const json = await response.json();
    if (process.env.NODE_ENV === 'development') {
      console.log("Form structure fetched successfully:", json);
    }
    return json;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error("Fetching form structure failed:", error);
    }
    throw error;
  }
};

const sendTypeForm = async (data: any) => {
  const endpoint = `${baseUrl}/wp-json/gf/v2/forms/4/submissions`;
  const authString = `${consumer_key_gf}:${secret_key_gf}`;
  const base64Auth = Buffer.from(authString).toString("base64");
  const FormData = {
    input_20: data.name,
    input_19: data.email,
    input_18: data.contact,
    input_11: data.service,
    input_12: data.location,
    input_13: data.size,
    input_15: data.timeline,
    input_16: data.description,
    input_17: data.meet
  };
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Auth}`,
    },
    body: JSON.stringify(FormData),
  };

  try {
    const response = await fetch(endpoint, options);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    if (process.env.NODE_ENV === 'development') {
      console.log("API Response:", response.statusText);
    }
    return response.statusText;
  } catch (error: any) {
    if (process.env.NODE_ENV === 'development') {
      console.error("Form submission error:", error);
    }
    throw error;
  }
};

export { submitFormById, fetchFormStructureById, sendTypeForm };
